import { render } from "./AttachFileDetails.vue?vue&type=template&id=e17f2504&scoped=true"
import script from "./AttachFileDetails.vue?vue&type=script&lang=js"
export * from "./AttachFileDetails.vue?vue&type=script&lang=js"

import "./AttachFileDetails.vue?vue&type=style&index=0&id=e17f2504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e17f2504"]])

export default __exports__